import { TOKEN_KEY, USER_ROLE_KEY } from '../utils/constants';

export const AUTH_SESSION_ENDED_EVENT = 'auth-session-ended';
const AUTH_SESSION_MESSAGE_KEY = 'auth-session-message';

export interface AuthSessionEndedDetail {
  code?: string;
  message?: string;
}

export const clearStoredAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_ROLE_KEY);
};

export const stashSessionEndedMessage = (message: string) => {
  sessionStorage.setItem(AUTH_SESSION_MESSAGE_KEY, message);
};

export const consumeSessionEndedMessage = (): string | null => {
  const message = sessionStorage.getItem(AUTH_SESSION_MESSAGE_KEY);
  if (message) {
    sessionStorage.removeItem(AUTH_SESSION_MESSAGE_KEY);
  }
  return message;
};

export const emitSessionEndedEvent = (detail: AuthSessionEndedDetail) => {
  window.dispatchEvent(new CustomEvent<AuthSessionEndedDetail>(AUTH_SESSION_ENDED_EVENT, { detail }));
};
